import React, { memo } from 'react'

function BlankPage () {
  return (
    <div>
      <h1>Сарафан - поиск профессионалов</h1>
      <hr/>
      <p>Добро пожаловать! Воспользуйтесь меню слева.</p>
    </div>
  )
}

export default memo(BlankPage)



// WEBPACK FOOTER //
// ./src/pages/BlankPage/index.jsx